import { handleActions } from "redux-actions";

const INITIAL_STATE = {
  tableData: {},
  inactiveTableData: {},
};

const DiscountCouponReducer = handleActions(
  {
    GET_LIVE_COUPON_DATA: (state, action) => {
      return {
        ...state,
        tableData: action.payload,
      };
    },
    GET_INACTIVE_COUPON_DATA: (state, action) => {
      return {
        ...state,
        inactiveTableData: action.payload,
      };
    },
  },
  
  INITIAL_STATE,
);


export default DiscountCouponReducer;